<template>
<div>
    <div class="ibox animated fadeInRightBig">
        <div class="ibox-title">
            <h3>Novo Cargo <i class="fa fa-address-card-o" style="float:right;font-size:21px;margin-top: -5px;"></i></h3>
        </div>
        <form id="form">
            <div class="ibox-content">
                <div class="row">
                    <div class="form-group col-md-12">
                        <label for="name"><span class="required">*</span> Nome do Cargo</label>
                        <input type="text" class="form-control" name="name" v-model="role.name" id="name">
                    </div>
                </div>
            </div>
            <div class="ibox-footer">
                <div class="pull-right">
                    <router-link to="/roles" class="btn btn-info">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-success" @click="save">
                        Salvar <i class="fa fa-save"></i>
                    </a>
                </div>
                <p><span class="required">*</span> Campos Obrigatórios</p>
                <div class="clearfix"></div>
            </div>
        </form>
    </div>
</div>
</template>

<script>
    export default {
        data() {
            return {
                role: {
                    name: '',
                },
                errors: undefined
            }
        },
        computed: {},
        methods: {
            save: function () {
                const self = this;
                const api = self.$store.state.api + 'roles';

                self.$http.post(api, self.role)
                    .then((response) => {
                        self.roles = response.data.data;
                        self.tableData = self.roles;

                        self.$message('Sucesso', `Cargo cadastrado !`, 'success');

                        this.$router.push('/roles');

                        self.role = {
                            name: ''
                        };
                    })
                    .catch((error) => {
                        self.errors = error.response.data;

                        if(typeof self.errors === 'object'){
                            let html = '<ul>';

                            $.each(self.errors, function(key, value){
                                html += '<li>' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    });
            },
            getRoles(){
                const self = this;
                const api = self.$store.state.api + 'roles';

                self.$http.get(api)
                .then(function (response) {
                    // console.log(response);
                });
            }

        },

        mounted: function(){
            // console.log(this.$store.state.user);
            this.getRoles();
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Role/Add.vue